import React from 'react';

const Minimal = props => {
    const { children } = props;

    return (
        <div>
            <main>{children}</main>
        </div>
    );
};

export default Minimal;
// import React, { useState } from 'react';
// import { useHistory, useLocation } from 'react-router-dom';
// import { AppBar, Toolbar, makeStyles, ListItem, ListItemIcon, Drawer, IconButton } from '@material-ui/core';
// import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
// import CreditCardIcon from '@material-ui/icons/CreditCard';
// import ExitToAppIcon from '@material-ui/icons/ExitToApp';
// import MenuIcon from '@material-ui/icons/Menu';
// import CloseIcon from '@material-ui/icons/Close';
// import useMediaQuery from '@material-ui/core/useMediaQuery';
// import { useTheme } from '@material-ui/core/styles';
//
// const useStyles = makeStyles((theme) => ({
//     header: {
//         height: '96vh',
//         width: '85px',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: theme.spacing(2),
//         background: "linear-gradient(to bottom, #FFAC46 0%, #FF5979 30%, #E7466E 100%)",
//         position: 'fixed',
//         top: '15px',
//         left: '15px',
//         borderRadius: '20px',
//         paddingTop: '30px',
//     },
//     navLinks: {
//         display: 'flex',
//         flexDirection: 'column',
//         gap: theme.spacing(2),
//     },
//     navItem: {
//         justifyContent: 'center',
//         paddingRight: '6px',
//     },
//     drawerPaper: {
//         width: '240px',
//         background: "linear-gradient(to bottom, #FFAC46 0%, #FF5979 30%, #E7466E 100%)",
//         [theme.breakpoints.down('sm')]: {
//             width: '65px',
//         },
//     },
//     menuButton: {
//         color: '#FFF',
//     },
//     closeButton: {
//         color: '#FFF',
//         alignSelf: 'flex-end',
//         margin: theme.spacing(1),
//     },
//     content: {
//         marginLeft: '100px',
//         padding: '20px',
//         [theme.breakpoints.down('sm')]: {
//             marginLeft: '0px',
//         },
//     },
//     appBarMobile: {
//         position: 'fixed',
//         top: '7px',
//         left: '7px',
//         width: '15%',
//         borderRadius:'15px',
//         background: "linear-gradient(to bottom, #FFAC46 0%, #FF5979 30%, #E7466E 100%)",
//     },
// }));
//
// const Minimal = (props) => {
//     const { children } = props;
//     const location = useLocation();
//     const history = useHistory();
//     const path = location.pathname;
//     const classes = useStyles();
//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//
//     const [drawerOpen, setDrawerOpen] = useState(false);
//
//     const handleToggleDrawer = () => {
//         setDrawerOpen(!drawerOpen);
//     };
//
//     const handleNavigate = (route) => {
//         history.push(route);
//         setDrawerOpen(false);
//     };
//
//     return (
//         <div style={{ backgroundColor: '#F4EEEE', minHeight: '100vh' }}>
//             {isMobile ? (
//                 <>
//                     <AppBar position="static" className={classes.appBarMobile}>
//                         <Toolbar>
//                             <IconButton
//                                 disableGutters
//                                 edge="start"
//                                 className={classes.menuButton}
//                                 onClick={handleToggleDrawer}
//                             >
//                                 <MenuIcon />
//                             </IconButton>
//                         </Toolbar>
//                     </AppBar>
//                     <Drawer
//                         anchor="left"
//                         open={drawerOpen}
//                         onClose={handleToggleDrawer}
//                         classes={{ paper: classes.drawerPaper }}
//                     >
//                         <IconButton className={classes.closeButton} onClick={handleToggleDrawer}>
//                             <CloseIcon />
//                         </IconButton>
//                         <div className={classes.navLinks}>
//                             <ListItem
//                                 disableGutters
//                                 className={classes.navItem}
//                                 selected={path === '/welcome'}
//                                 button
//                                 onClick={() => handleNavigate('/welcome')}
//                             >
//                                 <ListItemIcon style={{ minWidth: 0, justifyContent: 'center', display: 'flex' }}>
//                                     <HomeOutlinedIcon style={{ color: '#F4F4F4' }} />
//                                 </ListItemIcon>
//                             </ListItem>
//                             <ListItem
//                                 disableGutters
//                                 className={classes.navItem}
//                                 selected={path === '/subscribe'}
//                                 button
//                                 onClick={() => handleNavigate('/subscribe')}
//                             >
//                                 <ListItemIcon style={{ minWidth: 0, justifyContent: 'center', display: 'flex' }}>
//                                     <CreditCardIcon style={{ color: '#F4F4F4' }} />
//                                 </ListItemIcon>
//                             </ListItem>
//                             <ListItem
//                                 disableGutters
//                                 className={classes.navItem}
//                                 selected={path === '/login'}
//                                 button
//                                 onClick={() => handleNavigate('/login')}
//                             >
//                                 <ListItemIcon style={{ minWidth: 0, justifyContent: 'center', display: 'flex' }}>
//                                     <ExitToAppIcon style={{ color: '#F4F4F4' }} />
//                                 </ListItemIcon>
//                             </ListItem>
//                         </div>
//                     </Drawer>
//                 </>
//             ) : (
//                 <div className={classes.header}>
//                     <div className={classes.navLinks}>
//                         <ListItem
//                             disableGutters
//                             className={classes.navItem}
//                             selected={path === '/welcome'}
//                             button
//                             onClick={() => handleNavigate('/welcome')}
//                         >
//                             <ListItemIcon style={{ minWidth: 0, justifyContent: 'center', display: 'flex' }}>
//                                 <HomeOutlinedIcon style={{ color: '#F4F4F4' }} />
//                             </ListItemIcon>
//                         </ListItem>
//                         <ListItem
//                             disableGutters
//                             className={classes.navItem}
//                             selected={path === '/subscribe'}
//                             button
//                             onClick={() => handleNavigate('/subscribe')}
//                         >
//                             <ListItemIcon style={{ minWidth: 0, justifyContent: 'center', display: 'flex' }}>
//                                 <CreditCardIcon style={{ color: '#F4F4F4' }} />
//                             </ListItemIcon>
//                         </ListItem>
//                         <ListItem
//                             disableGutters
//                             className={classes.navItem}
//                             selected={path === '/login'}
//                             button
//                             onClick={() => handleNavigate('/login')}
//                         >
//                             <ListItemIcon style={{ minWidth: 0, justifyContent: 'center', display: 'flex' }}>
//                                 <ExitToAppIcon style={{ color: '#F4F4F4' }} />
//                             </ListItemIcon>
//                         </ListItem>
//                     </div>
//                 </div>
//             )}
//             <main className={classes.content}>{children}</main>
//         </div>
//     );
// };
//
// export default Minimal;
